/** @format */
import { MediaQuery } from '@mpb-com/feather/helpers/media-queries';
import { createGlobalStyle, css } from 'styled-components';

export const UspTooltipGlobalStyles = createGlobalStyle`
    .usp-tooltip .tooltip-inner {
        width: 280px;
        text-align: left;
    }
`;

const baseStyles = () => {
    /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
    return css`
        display: flex;
        padding: var(--layout-spacing-2);
        gap: var(--layout-spacing-4);
        max-width: 14rem;

        position: absolute;
        right: var(--layout-spacing-8);
        top: var(--layout-spacing-8);

        border-radius: 0.4rem;
        border: 1px solid var(--colors-border-secondary);
        background: var(--colors-surface-inverse);
        z-index: 1;

        .icon-container {
            grid-area: icon;
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-shrink: 0;
            align-self: stretch;
            padding: 3px var(--layout-spacing-2);
            cursor: pointer;
        }

        .icon {
            border: 1px solid #fff;
            padding: 3px;
            width: 12px;
            height: 12px;
        }

        .icon path {
            fill: #fff;
        }

        .icon svg {
            width: 8px;
            height: 8px;
        }

        .icon svg path {
            fill: #fff;
        }

        .usp-tag {
            grid-area: tag;
            text-align: left;
            text-wrap: wrap;
            padding: var(--layout-spacing-2);

            color: #fff;
            font-size: var(--typography-font-size-sm);
            font-weight: var(--typography-weight-light);
            line-height: var(--typography-line-height-normal);
            letter-spacing: var(--typography-letter-spacing-tight);
        }

        @media only screen and ${MediaQuery.LARGE_TABLET} {
            max-width: 17rem;
        }
    `;
    /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
};

export const styles = () => css`
    ${baseStyles()}
`;
